import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Copropriete extends Entity {

  @deserializeAs(Boolean, 'in_copropriete')
  inCopropriete;

  @deserializeAs('numero_immatriculation_copropriete')
  numeroImmatriculationCopropriete;

  @deserializeAs('numero_lot')
  numeroLot;
}
